import type { PotSize } from "@/types";

/** Typical indoor pot soil volume estimates (liters); tune in one place. */
export const POT_SIZE_LITERS: Record<PotSize, number> = {
  small: 1,
  medium: 5,
  large: 15,
};

export const POT_SIZE_ORDER: PotSize[] = ["small", "medium", "large"];

/** e.g. ~5 L */
export function formatApproxVolumeLiters(size: PotSize): string {
  return `~${POT_SIZE_LITERS[size]} L`;
}

/** e.g. Medium (~5 L) */
export function potSizeShortLabel(size: PotSize): string {
  const L = POT_SIZE_LITERS[size];
  const name = size.charAt(0).toUpperCase() + size.slice(1);
  return `${name} (~${L} L)`;
}
